module.exports = __webpack_public_path__ + "img/75720.c6482b9f.svg";